import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/red_cros.svg")